import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: 'app-coverage-color-picker',
  templateUrl: './coverage-color-picker.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class CoverageColorPickerComponent implements OnInit {

  @Input() coverageColor : string;
  onClose: Subject<string>;

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    this.onClose = new Subject();
  }
  ok(){
    this.onClose.next(this.coverageColor);
    this.bsModalRef.hide();
  }



}
